"use client"

import { formatFileSize } from "@/lib/pdf-splitter-api"
import type { StorageQuotaData } from "./types"

interface StorageGaugeProps {
  storageQuota: StorageQuotaData | null
  quotaLoadFailed: boolean
}

export function StorageGauge({ storageQuota, quotaLoadFailed }: StorageGaugeProps) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <span className="font-medium text-foreground/80">Storage</span>
        {storageQuota ? (
          <span>
            {formatFileSize(storageQuota.usedBytes)} / {formatFileSize(storageQuota.limitBytes)}
          </span>
        ) : quotaLoadFailed ? (
          <span className="text-muted-foreground/60">Unavailable</span>
        ) : (
          <span className="text-muted-foreground/60">Loading...</span>
        )}
      </div>
      {!quotaLoadFailed && (
        <div className="h-2 bg-muted rounded-full overflow-hidden">
          <div
            className={`h-full transition-all duration-500 ease-out rounded-full ${
              storageQuota
                ? storageQuota.usagePercentage > 90
                  ? "bg-destructive"
                  : storageQuota.usagePercentage > 70
                    ? "bg-yellow-500"
                    : "bg-primary"
                : "bg-muted-foreground/20"
            }`}
            style={{ width: `${storageQuota?.usagePercentage || 0}%` }}
          />
        </div>
      )}
      {storageQuota && storageQuota.usagePercentage > 80 && (
        <p className="text-yellow-600 dark:text-yellow-400">
          {storageQuota.usagePercentage > 90
            ? "Storage almost full! Delete old files to continue."
            : "Storage getting full."}
        </p>
      )}
    </div>
  )
}
